var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlockCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25201",
    "data-name": "Group 25201",
    transform: "translate(-47 -427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24802",
    "data-name": "Group 24802",
    transform: "translate(-1188.999 105.091)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1235.999 321.909)",
    fill: "#396"
  })), /*#__PURE__*/React.createElement("g", {
    id: "locked-padlock",
    transform: "translate(-9.803 432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(63.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7347",
    "data-name": "Path 7347",
    d: "M72.75,4.5h-.643V3.214a3.214,3.214,0,0,0-6.429,0V4.5h-.643A1.29,1.29,0,0,0,63.75,5.786v6.429A1.29,1.29,0,0,0,65.036,13.5H72.75a1.29,1.29,0,0,0,1.286-1.286V5.786A1.29,1.29,0,0,0,72.75,4.5Zm-3.857,5.786A1.286,1.286,0,1,1,70.179,9,1.29,1.29,0,0,1,68.893,10.286ZM70.886,4.5H66.9V3.214a1.993,1.993,0,0,1,3.986,0Z",
    transform: "translate(-63.75)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockCircle);
export default __webpack_public_path__ + "static/media/padlock-circle.6185d7d93a6b9038e259692055a96c72.svg";
export { ForwardRef as ReactComponent };